// Imports
import { useEffect, useState, Fragment, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
//Language
import { useIntl } from "react-intl";
// Controls
import { Grid } from '@mui/material';
import { NotificationManager } from "Components/Notifications";
import { Button, Modal, ModalBody, ModalFooter } from "@gpstrackit/react-controls";
import DataView from 'Components/DataView';
import { getDateFormatted } from 'Core/data/Helpers';
import ShowJSONCompare from '../../../.common/.components/showJSONCompare';

// Actions
import {
    showJSONCompareModal,
    showChangesHistoryHide,
    clearRedux,
} from "Redux/actions";

// Styles
import './showChangesHistory.scss';


const ShowChangesHistory = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //initial filter status
    const initialStateFilters = {
        esn: props?.device?.ESN || '',
    }
    //Table reference
    const tableRef = useRef(null);

    //redux states

    const openModal = useSelector(state => state.showChangesHistoryRedux.openModal);
    const list = useSelector(state => state.showChangesHistoryRedux.Items);
    const loading = useSelector(state => state.showChangesHistoryRedux.showChangesHistoryLoading);
    const error = useSelector(state => state.showChangesHistoryRedux.error);
    const errorCode = useSelector(state => state.showChangesHistoryRedux.errorCode);
    const openModalShowJSONCompare = useSelector(state => state.showJSONCompareRedux.openModal);

    //local states
    const [filters, setFilters] = useState(initialStateFilters);
    const [showCompare, setShowCompare] = useState(false);
    const [dataToCompare, setDataToCompare] = useState(null);

    const [columns, setColumns] = useState([

        {
            key: 'version',
            show: true,
            locked: true,
            title: messages["show_changes_history_version"],
            width: 150,
            field: "version",
            render: (item) => {
                return (
                    <span>{item?.version || ''}</span>
                )
            }
        },
        {
            key: 'settingsChangeTime',
            show: true,
            locked: true,
            title: messages["show_changes_history_updated_on"],
            width: 200,
            field: "settingsChangeTime",
            render: (item) => {
                return (
                    <div>
                        {
                            item.settingsChangeTime &&
                            getDateFormatted(item.settingsChangeTime, "long", "datetime")
                        }
                    </div>
                )
            }
        },
        {
            key: 'settings',
            show: true,
            locked: true,
            title: "",
            width: 200,
            render: (item) => {
                return (
                    <div>
                        {
                            item?.previousVersion &&
                            <a className="btn-link align-middle" onClick={() => {
                                //to show differences
                                let toCompare = { newData: item.cloudConfigure, newVersion: item.version, oldData: item.lastChange.cloudConfigure, oldVersion: item.lastChange.version }
                                setDataToCompare(toCompare);
                                dispatch(showJSONCompareModal())
                            }}>
                                {messages["show_changes_history_view_changes"]}
                            </a>
                        }
                    </div>
                )
            }
        }
    ]);

    const hide = () => {

        setFilters({ esn: "" });
        dispatch(showChangesHistoryHide());
        dispatch(clearRedux("SHOW_CHANGES_HISTORY", { Items: [], error: null, errorCode: null }))
    }

    const templateChange = (entity, oldVal, newVal) => {
        oldVal = oldVal && oldVal.toString() || null;
        return (
            <div>
                {entity}
                <br />
                {`(${oldVal && oldVal.length > 0 && oldVal || "None"} → ${newVal})`}
            </div>
        )
    }

    useEffect(() => {
        if (error) {
            if (filters.esn) {
                NotificationManager.error(
                    "",
                    errorCode === 403 ? messages['vidfleet.erroresnpermission'] : messages['vidfleet.erroresn'],
                    3000,
                    null,
                    null,
                    'error'
                );
            } else {
                NotificationManager.error(
                    "",
                    messages['show_changes_history_error'],
                    3000,
                    null,
                    null,
                    'error'
                );
            }
            dispatch(clearRedux("SHOW_CHANGES_HISTORY", { error: null, errorCode: null }));
        }

    }, [error]);

    return (
        <Fragment>
            <Modal
                open={openModal}
                title={messages["show_changes_history_title"]}
                handleClose={() => hide()}
                position="right"
                loading={loading}
                size="medium"
            >
                <ModalBody style={{ backgroundColor: '#f8f8f8' }}>
                    <Grid>
                        <Grid xxs="12">
                            <DataView
                                ref={tableRef}
                                name="showChangesHistoryListView"
                                exportName="changeshistory"
                                externalLoading={loading}
                                externalData={list}
                                columns={columns}
                                noExcel
                                noSearch
                                noDensity
                                noFilters
                                noRefresh
                                noSplit
                                messages={messages}
                                setColumns={setColumns}
                                height='calc(100vh - 400px)'
                                disableItemSelection
                                hidePagination
                            />
                        </Grid>
                    </Grid>
                </ModalBody>
                <ModalFooter>
                    <Button className="btn btn-dark-blue"
                        onClick={() => hide()}
                    >
                        {messages["common_cancel"]}
                    </Button>
                </ModalFooter>
            </Modal>

            {
                openModalShowJSONCompare &&
                <ShowJSONCompare
                    title={`${messages["show_changes_history_compare_vesions"]} ${dataToCompare?.oldVersion} --> ${dataToCompare?.newVersion}`}
                    newData={dataToCompare && dataToCompare.newData && JSON.parse(JSON.stringify(dataToCompare.newData))}
                    oldData={dataToCompare && dataToCompare.oldData && JSON.parse(JSON.stringify(dataToCompare.oldData))} />
            }
        </Fragment>
    );
};

export default ShowChangesHistory;